<template>
    <div class="home main-con">
        <template v-if="showDesktop">
            <div class="header-wrapper">
                <div class="con-wrapper">
                    <main-header></main-header>
                    <div class="banner-wrapper row">
                        <div class="col-xs-12 col-sm-6 align-items-start">
                            <p-register-card ref="register-card"></p-register-card>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile-list-wrapper">
                <div class="con-wrapper row">
                    <div v-for="profile in profiles" class="profile-con col-xs-12 col-sm-2">
                        <div class="card-con">
                            <router-link :to="{ name: 'login' }" class="pic-con">
                                <img :src="profile.thumb_picture" class="profile-pic img-responsive">
                            </router-link>
                            <div class="profile-details">
                                <h3 class="nick-name">{{ profile.nick_name }}</h3>
                                <p class="age-province">{{ profile.age }}, {{ profile.province_name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="additional-contents">
                <div class="features-con">
                    <div class="items-con row">
                        <div class="col-xs-12 col-sm-6">
                            <div class="contents">
                                <h3 v-html="midSecTitle" />
                                <p v-html="midSecSlogan" />
                                <button class="btn btn-white-orange" @click="gotoTop">
                                    <span v-html="midSecButton" />
                                </button>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <div class="illustration">
                                <img :src="`${cdn_url}/images/icon_group.png`" alt="card" class="img-responsive">
                            </div>
                        </div>
                    </div>
                    <div class="items-con row">
                        <div class="col-xs-12 col-sm-6">
                            <div class="illustration small second">
                                <img :src="`${cdn_url}/images/mobile.png`" alt="card" class="img-responsive">
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <div class="contents">
                                <h3 v-html="contentLeftTitle" />
                                <p v-html="contentLeftText" />
                                <a v-if="content.content_left_button_url && content.content_left_button_url != '#'" :href="content.content_left_button_url" v-html="contentLeftButton" />
                                <button class="btn btn-white-orange" @click="gotoTop">
                                    <span v-if="content.content_left_button_url && content.content_left_button_url != '#'"
                                    :href="content.content_left_button_url" v-html="contentLeftButton" />
                                    <span v-else href="/" @click.stop.prevent="gotoTop" v-html="contentLeftButton" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="items-con row">
                        <div class="col-xs-12 col-sm-6">
                            <div class="contents">
                                <h3 v-html="contentRightTitle" />
                                <p v-html="contentRightText" />
                                <button class="btn btn-white-orange" @click="gotoTop">
                                    <span v-if="content.content_right_button_url && content.content_right_button_url != '#'"
                                    :href="content.content_right_button_url" v-html="contentRightButton" />
                                    <span v-else href="/" @click.stop.prevent="gotoTop" v-html="contentRightButton" />
                                </button>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <div class="illustration small">
                                <img :src="`${cdn_url}/images/cards.png`" alt="card" class="img-responsive">
                            </div>
                        </div>
                    </div>
                </div>
                <main-footer></main-footer>
            </div>
        </template>
        <template v-else>
            <div class="con-wrapper mobile">
                <div class="top-nav-con">
                    <div class="logo-con">
                        <router-link :to="{ name: 'home' }">
                            <img class="img-responsive" :src="`${icdn_url}/desktop-logo-footer.png`" :alt="`White logo ${site_name}`" v-cloak>
                        </router-link>
                    </div>
                    <div class="menu-con">
                        <i :class="`icon ${mobile_menu_opened ? 'icon-close' : 'icon-burger-white'}`" @click="openMobileMenu"></i>
                    </div>
                </div>
                <mobile-menu 
                    ref="mobile-menu" 
                    :init-opened="mobile_menu_opened"
                    @menuClicked="openMobileMenu"
                />
                <div :class="`button-con ${with_cookie_notice ? 'with-cookie-notice' : ''}`">
                    <div class="button-wrapper">
                        <button class="btn btn-orange" @click="toRegister" v-html="boxButton" />
                        <button class="btn btn-white-orange disable-hover" @click="$router.push({ name: 'login' })">{{ 'Login' | translate }} </button>
                    </div>
                </div>
            </div>
        </template>
        <cookies-notice></cookies-notice>
    </div>
</template>

<script>
import MainHeader from '@theme-views/common/MainHeader'
import MainFooter from '@theme-views/common/MainFooter'
import MobileMenu from '@theme-views/common/MobileMenu'
import PRegisterCard from '@theme-views/public/partials/PRegisterCard'
import CookiesNotice from '@theme-views/common/CookiesNotice'
import SvgWave from '@theme-views/common/SvgIcon/Icons/Wave'
import Home from '@views/public/pages/Home/home'

delete Home.methods.handleResize
delete Home.beforeDestroy
delete Home.mounted

export default {
    mixins: [Home],
    data() {
        return {
            content: window.APP_CONFIG.LANDING_PAGE_CONTENT,
            mobile_menu_opened: false,
            is_dev: process.env.NODE_ENV !== 'production',
        }
    },
    methods: {
        openMobileMenu() {
            this.$refs['mobile-menu'].openMenu()
            this.mobile_menu_opened = this.$refs['mobile-menu'].opened
        },
        toRegister() {
            this.$parent.changeModalContent({
                name: 'p-register-pop-up',
                hasCloseButton: false,
                alignCenter: true,
                canCloseBackDrop: true,
                extraClasses: "mobile-dark centered",
                mobileBreakpoint: 1199,
            })
            this.$parent.openModal()
        },
        handleResize() {
            this.$parent.closeModal()
        },
    },
    computed: {
        formValues() {
            return this.$store.getters['pub/formValues']
        },
        with_cookie_notice() {
            return !window.APP_CONFIG.COOKIE_POPUP && !this.$store.getters['cookies/isConsentApproved']
        },
        boxButton() {
            return this.content.registration_box_button ? this.content.registration_box_button : this.$t('SEARCH NOW')
        },
    },
    components: {
        MainHeader,
        MainFooter,
        MobileMenu,
        PRegisterCard,
        CookiesNotice,
        SvgWave
    },
    created() {
      window.addEventListener("contextmenu", this.handleRightClick)
    },
    beforeDestroy() {
      window.removeEventListener("contextmenu", this.handleRightClick)
    },
}
</script>

<style lang="scss" src="./home.scss"></style>
